module.exports = __webpack_public_path__ + "img/lagerausbildung-3bohrungen-en.b98a63c7.png";